import {
  AccessTimeOutlined,
  ArrowDropDownCircleOutlined,
  AttachMoneyOutlined,
  CalendarTodayOutlined,
  CheckBoxOutlined,
  CheckBoxOutlineBlankOutlined,
  CorporateFareOutlined,
  CreditCardOutlined,
  EventOutlined,
  ExpandCircleDownOutlined,
  LocationOnOutlined,
  LocalPhoneOutlined,
  NumbersOutlined,
  ShortTextOutlined,
  TableRowsOutlined,
  BarChart,
} from '@mui/icons-material'
import { SxProps } from '@mui/material'
import { FieldTypeName } from '@/types/fields'
import { getFormattedDateTimeString } from './time'

export default function getDataTypeIcon(data_type: FieldTypeName | 'custom') {
  switch (data_type) {
    case 'category':
      return ArrowDropDownCircleOutlined
    case 'text':
      return ShortTextOutlined
    case 'int':
      return NumbersOutlined
    case 'decimal':
      return NumbersOutlined
    case 'date':
      return CalendarTodayOutlined
    case 'time':
      return AccessTimeOutlined
    case 'datetime':
      return EventOutlined
    case 'currency':
      return AttachMoneyOutlined
    case 'organization':
      return CorporateFareOutlined
    case 'cc_num':
      return CreditCardOutlined
    case 'address':
      return LocationOnOutlined
    case 'phone':
      return LocalPhoneOutlined
    case 'grid':
      return TableRowsOutlined
    case 'checkbox':
      return CheckBoxOutlined
    case 'picker':
    case 'live-list-picker':
      return ExpandCircleDownOutlined
    case 'bar_chart':
      return BarChart
    default:
      return ShortTextOutlined
  }
}

export function getCheckboxFormattedValue(
  value: string,
  sxProps?: SxProps,
  onlyOCR = false,
) {
  if (value === 'TrueBox' || (!onlyOCR && value === 'True')) {
    return <CheckBoxOutlined fontSize="small" sx={sxProps} />
  }

  if (value === 'FalseBox' || (!onlyOCR && value === 'False')) {
    return <CheckBoxOutlineBlankOutlined fontSize="small" sx={sxProps} />
  }
  return value
}

export function getFormattedValue(
  value: string | null,
  fieldCode: FieldTypeName,
) {
  if (!value) return null

  switch (fieldCode) {
    case 'date':
    case 'time':
    case 'datetime':
      return getFormattedDateTimeString(value, fieldCode)
    case 'checkbox':
      return getCheckboxFormattedValue(value)
    default:
      return value
  }
}
